import React, { useState, useEffect } from 'react';
import Enumerable from 'linq';

//components material mui
import { Button, Grid, Typography, styled, ListItem, IconButton, Divider } from '@mui/material';

//icons
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

//config
import DiccionarioEtiquetas from '../../Configuracion/Idiomas/Etiquetas_Diccionario';
import { enlistaArrayCodigosMensajesIdiomas } from '../../Actions/Generales/IdiomasAction';
import { MostrarMensaje } from '../../Utilidades/ManejoMensajes';
import { GnlUrlClassStore, GnlUrlBaseServicios } from '../../Configuracion/Llaves/RepositorioConfig';

//context app
import { useStateValue } from '../../Contexto/store';

//components
import DetalleSubModuloExterno from './DetalleSubModuloExterno';

//actions
import { obtenerClave } from '../../Actions/ClassStore/ClassStoreAction';
import { obtenerAccesoClassStore } from '../../Actions/Usuarios/UsuarioAction';
import { obtenerDatosAppExternas } from '../../Actions/ClassStore/AppExternasAction';

//styles
import { styleDetalleModulo } from '../Tool/Style';
import { createStyles, makeStyles } from '@mui/styles';

//styled component
const useStyles = makeStyles(() =>
    createStyles({
        customAccordionSummary: {
            justifyContent: 'space-around',
            margin: '20px 0px 0px 32px !important'
        }
    }));

const AccordionStyled = styled(Accordion)`
   &:before{
    position: absolute;
    left: 0px;
    top: -1px;
    right: 0px;
    height: 1px;
    content: "";
    opacity: 1;
    background-color: transparent;
   }
`

const DetalleModuloExterno = ({ listaSubmodulos, Imagen, Header, Detalles, LastOne }) => {
    const classes = useStyles();
    const [{ etiquetasIdioma, sesionUsuario, compania }, dispatch] = useStateValue();
    
    // Se declara la variable de estado que representa al idioma para las etiquetas del componente
    const [etiquetas, setEtiquetas] = useState({
        EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
        CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
    });

    useEffect(() => {
        // se llama al dispatch para que como tal se actualice el reducer
        setEtiquetas({
            EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
            CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
        });

    }, [etiquetasIdioma]);

    const [expanded, setExpanded] = useState(true);
    const [expandedFavoritos, setExpandedFavoritos] = useState(false);

    const [validClassStore, setValidClassStore] = useState(true);

    useEffect(() => {

        getAccesClassStore();

    }, []);

    const getAccesClassStore = async () => {

        const objReq = {
            userId: sesionUsuario.usuario.userId,
        };

        const response = await obtenerAccesoClassStore(objReq);

        if (response.status === 200) {
            setValidClassStore(response.data.accessClassStore);
        }

    };

    const getSecurity = async() => {

        const objReq = {
            userId: sesionUsuario.usuario.userId,
            peticionUsuario: {
                companyId: sesionUsuario.usuario.companyId,
                userId: sesionUsuario.usuario.userId,
                optionId: "00000000-0000-0000-0000-000000000000",
                action: 'C'
            }
        };

        const response = await obtenerClave(objReq);

        if (response.status === 200) {

            return { success:true, clave:response.data };

        } else {

            mostrarMesajeError(response);

            return { success: false, clave:'' };
        }
        
    }

    const mostrarMesajeError = (response) => {
        if (response.data.errors) {
            const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
            MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
        } else {
            MostrarMensaje(dispatch, 'error', [response.statusText]);
        }
    };

    const utf8ToBase64 = ( str )  => {
        return window.btoa(encodeURIComponent( str ));
    };

    const abrirNuevoTab = async () => {

        if (validClassStore === false) return;

        let stringDatos = "";

        const etiIdioma = window.localStorage.getItem("etiqueta_idioma");
        const peticionDatos = {
            UserEmail: sesionUsuario.usuario.email,
            CustomerId: sesionUsuario.usuario.customerId,
            FullName: sesionUsuario.usuario.nombreCompleto,
            BaseUrl: GnlUrlBaseServicios,
            CompanyId: sesionUsuario.usuario.companyId,
            CompanyName: compania.ComName,
            UserId: sesionUsuario.usuario.userId,
            Token: window.localStorage.getItem("token_seguridad"),
            LanguageCode: etiIdioma,
            ProfilePicture: ""//sesionUsuario.usuario.imagenPerfil
        };

        const responseDatos = await obtenerDatosAppExternas(peticionDatos);
        

        if (responseDatos.status === 200) //si la respuesta fue existosa
        {
            if (GnlUrlClassStore.includes("?"))
                stringDatos = "&";
            else
                stringDatos = "?";

            stringDatos += "q=" + responseDatos.data;
            var win = window.open(GnlUrlClassStore + stringDatos, '_blank');
            win.focus();
        }

        //const { clave, success } = await getSecurity();

        //let txtPasswordAndEmail = "";

        //if (success && GnlUrlClassStore !== "" && GnlUrlClassStore !== undefined && GnlUrlClassStore !== null) {

        //    txtPasswordAndEmail = utf8ToBase64(clave + '&&=' + sesionUsuario.usuario.email);
            
        //     var win = window.open(GnlUrlClassStore + txtPasswordAndEmail, '_blank');
        //    win.focus();
        //}
        
    };

    return (
        <ListItem style={styleDetalleModulo.ListItem}>
            {
                Detalles ?
                    (
                        <div style={styleDetalleModulo.divDetallesFull}>
                          {/* <div style={{display:'flex', justifyContent:'end'}}>
                                validClassStore === false
                                    ? null
                                    : <p style={{ cursor: 'pointer', fontWeight: 500, fontSize: "16px", color: 'rgb(34, 51, 84)', padding: "0px", textDecorationLine: 'underline' }}
                                      onClick={() => abrirNuevoTab()}>
                                      {etiquetas.EtiquetasComponente.Home.Et_IrTienda} 
                               </p> 
                             </div> */}
                            <img src={Imagen} style={{...styleDetalleModulo.imgArea, paddingTop:"10px"}} alt={"Favoritos"} onClick={() => setExpandedFavoritos(!expandedFavoritos)} />
                       
                           
                            <AccordionStyled elevation={0} square expanded={expandedFavoritos} style={{ backgroundColor: 'transparent' }}>
                            
                                <AccordionSummary style={{alignItems: 'end', paddingBottom:'12px'}} classes={{ content: classes.customAccordionSummary }}
                                    expandIcon={<IconButton
                                        style={styleDetalleModulo.IconExpansionPanelSummary}
                                        onClick={() => setExpandedFavoritos(!expandedFavoritos)}
                                        size="large">
                                        <ExpandMoreIcon color='primary' /></IconButton>}>

                                    <div style={{ display:'flex', flexDirection:'column' }}>

                                        <Typography onClick={() => setExpandedFavoritos(!expandedFavoritos)}
                                            variant='h5' style={validClassStore === false ? {} : { marginTop: "18px", marginBottom: "21px" }}>{Header}</Typography>

                                        {validClassStore === false
                                           ? null
                                           : <Button variant="contained"
                                                style={{
                                                    width: "145px",
                                                    height:"40px",
                                                    fontSize: "14px",
                                                    fontWeight:"500",
                                                   // textTransform:'inherit',
                                                    backgroundColor:'#F2CED0',
                                                    borderRadius:'100px',
                                                    border:'1px solid #DF2526',
                                                    color:'#DF2526',
                                                    paddig:'22px' }}
                                            onClick={() => abrirNuevoTab()}>
                                            {etiquetas.EtiquetasComponente.Home.Et_IrTienda} 
                                            </Button>
                                        }

                                       </div>

                                </AccordionSummary>

                                <AccordionDetails>
                                
                                    <Typography variant='h6'>{Enumerable.from(listaSubmodulos).first().LeyendaDB}</Typography>
                                
                                    <Grid container spacing={2} justifyContent="center" style={styleDetalleModulo.gridDetalles}>
                                        {
                                            listaSubmodulos.map(({ IdModuloDB, TituloDB, SubmoduloDB, UrlModuloDB, IconoDB, Referencia, ModuloExterno }, key) =>
                                                (<DetalleSubModuloExterno key={key} IdModulo={IdModuloDB} Titulo={TituloDB} Submodulo={SubmoduloDB} UrlModulo={UrlModuloDB} Icono={IconoDB} Detalles={Detalles} Referencia={Referencia} ModuloExterno={ModuloExterno} />)
                                            )
                                        }
                                    </Grid>
                                </AccordionDetails>
                            </AccordionStyled>
                            {LastOne ? null : <Divider style={{ marginTop: 30 }} />}
                        </div>
                    )
                    :
                    (
                        <div style={styleDetalleModulo.divDetalles}>
                             
                            <div style={{ textAlign: 'center' }}>

                                <Accordion elevation={0} style={styleDetalleModulo.Accordion} square expanded={expanded}>
                                    <AccordionSummary style={styleDetalleModulo.Accordion} classes={{ content: classes.customAccordionSummary }}
                                        expandIcon={<IconButton
                                            style={styleDetalleModulo.IconExpansionPanelSummary}
                                            onClick={() => setExpanded(!expanded)}
                                            size="large">
                                            <ExpandMoreIcon color='primary' /></IconButton>}>
                                        <Typography onClick={() => setExpanded(!expanded)} variant='h5' >{Header}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Grid container spacing={2} justifyContent="center" style={styleDetalleModulo.gridDetalles}>
                                            {
                                                listaSubmodulos.map(({ IdModuloDB, TituloDB, SubmoduloDB, UrlModuloDB, IconoDB, Referencia, ModuloExterno }, key) =>
                                                    (<DetalleSubModuloExterno key={key} IdModulo={IdModuloDB} Titulo={TituloDB} Submodulo={SubmoduloDB} UrlModulo={UrlModuloDB} Icono={IconoDB} Detalles={Detalles} Referencia={Referencia} ModuloExterno={ModuloExterno} />)
                                                )
                                            }
                                        </Grid>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        </div>
                    )
            }
        </ListItem>
    );
}

export default DetalleModuloExterno;